// CacheKey 5cc6cb078a792b21cde50832cf4f69df
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  en: {
    default_page_title: "Evolve by CipherHealth · Care Smarter",
    custom_page_title: "%{title} · Evolve by CipherHealth",
    password_change_required: "One of your care providers requires a password change. Please change your password.",
    password_reset_link_expired: "Your password reset link has expired. These links are set to expire after %{expiration_interval} hours. Please use this page to request a link to be sent to your email immediately.",
    orchid_settings_invalid_error: "Your default configuration is not right, please contact support@cipherhealth.com",
    continue_on: "Welcome to CipherHealth! To continue, please use the navigation bar above.",
    views: {
      pagination: {
        next: "&#x2192;",
        previous: "&#x2190;"
      }
    },
    mongoid: {
      models: {
        outreach_action: "Outreach Action",
        questions_group: "Questions Group"
      },
      attributes: {
        hl7_name: {
          hl7_name: "HL7 Name"
        },
        hl7_ip_address: {
          ip_address: "IP Address"
        },
        whitelist_ip_address: {
          ip_address: "IP Address"
        },
        care_provider: {
          fallback_patient_matching: "Secondary Patient Matching",
          primary_patient_matching: "Primary Patient Matching",
          tertiary_patient_matching: "Tertiary Patient Matching",
          encounter_id_fields: "Encounter ID Fields",
          warehouse_data_retention_enabled: "Warehouse Data Retention"
        },
        encounter: {
          encounter_id: "Encounter ID"
        },
        enrollment: {
          alternate_member_id: "Alternate Member ID",
          member_id: "Member ID",
          pcp_id: "Pcp ID",
          subscriber_id: "Subscriber ID"
        },
        referral: {
          referral_id: "Referral ID",
          referred_to_provider_id: "Referred to provider ID",
          referred_to_department_id: "Referred to department ID"
        }
      },
      errors: {
        models: {
          hl7_settings: {
            attributes: {
              hl7_names: {
                taken: "already exists",
                in_other_cp: "with ip address \"%{ip_address}\" exists in %{care_providers} already. Please check that this is correct."
              },
              hl7_ip_addresses: {
                invalid: "format is incorrect",
                taken: "already exists",
                in_other_cp: "with hl7 name \"%{name}\" exists in %{care_providers} already. Please check that this is correct."
              }
            }
          },
          hl7_ip_address: {
            attributes: {
              ip_address: {
                invalid: "format is incorrect",
                taken: "already exists",
                in_other_cp: "with hl7 name \"%{name}\" exists in %{care_providers} already. Please check that this is correct."
              }
            }
          },
          whitelist_ip_address: {
            attributes: {
              ip_address: {
                invalid: "format is incorrect",
                taken: "already exists"
              }
            }
          },
          hl7_name: {
            attributes: {
              hl7_name: {
                taken: "already exists",
                in_other_cp: "with ip address \"%{ip_address}\" exists in %{care_providers} already. Please check that this is correct."
              }
            }
          },
          care_provider: {
            attributes: {
              primary_patient_matching: {
                form_field_missing: "contains fields which are not present in Form Fields",
                different_than_fallback: "should be different than Secondary Patient Matching",
                different_than_tertiary: "should be different than Tertiary Patient Matching"
              },
              fallback_patient_matching: {
                form_field_missing: "contains fields which are not present in Form Fields",
                different_than_tertiary: "should be different than Tertiary Patient Matching"
              },
              tertiary_patient_matching: {
                form_field_missing: "contains fields which are not present in Form Fields"
              },
              encounter_id_fields: {
                form_field_missing: "contains fields which are not present in Form Fields"
              },
              duplicate_call_programs: {
                duplicate_call_programs_must_be_unique: "contains same outreach program more than once"
              }
            }
          },
          form_field_settings: {
            attributes: {
              required_patient_form_fields: {
                form_field_missing: " contains fields which are not present in New Patient Form Fields"
              },
              required_encounter_form_fields: {
                form_field_missing: " contains fields which are not present in New Encounter Form Fields"
              },
              required_enrollment_form_fields: {
                form_field_missing: " contains fields which are not present in New Enrollment Form Fields"
              }
            }
          },
          "data_exchange/association": {
            attributes: {
              mappings: {
                duplicated: "%{duplicates} are duplicated in the Association Mapping.",
                key_metric_missing_field: "%{type} Key Metric has missing '%{missing_field}' field.",
                required: "%{required} are required fields."
              }
            }
          },
          survey_device: {
            attributes: {
              login_id: {
                taken: "is already taken. Note: Logins are global so they must be unique between all Care Providers"
              }
            }
          },
          duplicate_call_program: {
            attributes: {
              outreach_program_ids_to_check: {
                blank: "target programs can't be blank"
              }
            }
          }
        }
      }
    },
    helpers: {
      submit: {
        care_provider: {
          create: "Create Care Provider",
          update: "Update Care Provider"
        },
        free_text_question: {
          create: "Create Question",
          update: "Update Question"
        },
        data_view: {
          create: "Create View",
          update: "Update View"
        },
        conditional_format: {
          create: "Create Rule",
          update: "Update Rule"
        }
      }
    },
    hl7_events: {
      ACK: "General acknowledgment message",
      ADR_A19: "Patient query",
      ADT_A01: "Admit/visit notification",
      ADT_A02: "Transfer a patient",
      ADT_A03: "Discharge/end visit",
      ADT_A04: "Register a patient",
      ADT_A05: "Pre-admit a patient",
      ADT_A06: "Change an outpatient to an inpatient",
      ADT_A07: "Change an inpatient to an outpatient",
      ADT_A08: "Update patient information",
      ADT_A09: "Patient departing - tracking",
      ADT_A10: "Patient arriving - tracking",
      ADT_A11: "Cancel admit/visit notification",
      ADT_A12: "Cancel transfer",
      ADT_A13: "Cancel discharge/end visit",
      ADT_A14: "Pending admit",
      ADT_A15: "Pending transfer",
      ADT_A16: "Pending discharge",
      ADT_A17: "Swap patients",
      ADT_A18: "Merge patient information",
      ADT_A20: "Bed status update",
      ADT_A21: "Patient goes on a \"leave of absence\"",
      ADT_A22: "Patient returns from a \"leave of absence\"",
      ADT_A23: "Delete a patient record",
      ADT_A24: "Link patient information",
      ADT_A25: "Cancel pending discharge",
      ADT_A26: "Cancel pending transfer",
      ADT_A27: "Cancel pending admit",
      ADT_A28: "Add person information",
      ADT_A29: "Delete person information",
      ADT_A30: "Merge person information",
      ADT_A31: "Update person information",
      ADT_A32: "Cancel patient arriving - tracking",
      ADT_A33: "Cancel patient departing - tracking",
      ADT_A34: "Merge patient information - patient id only",
      ADT_A35: "Merge patient information - account number only",
      ADT_A36: "Merge patient information - patient id and account number",
      ADT_A37: "Unlink patient information",
      ADT_A38: "Cancel pre-admit",
      ADT_A39: "Merge person - patient id",
      ADT_A40: "Merge patient - patient identifier list",
      ADT_A41: "Merge account - patient account number",
      ADT_A42: "Merge visit - visit number",
      ADT_A43: "Move patient information - patient identifier list",
      ADT_A44: "Move account information - patient account number",
      ADT_A45: "Move visit information - visit number",
      ADT_A46: "Change patient id (for backward compatibility only)",
      ADT_A47: "Change patient identifier list",
      ADT_A48: "Change alternate patient id",
      ADT_A49: "Change patient account number",
      ADT_A50: "Change visit number",
      ADT_A51: "Change alternate visit id",
      ADT_A52: "Cancel leave of absence for a patient",
      ADT_A53: "Cancel patient returns from a leave of absence",
      ADT_A54: "Change attending doctor",
      ADT_A55: "Cancel change attending doctor",
      ADT_A60: "Update allergy information",
      ADT_A61: "Change consulting doctor",
      ADT_A62: "Cancel change consulting doctor",
      BAR_P01: "Add patient accounts",
      BAR_P02: "Purge patient accounts",
      BAR_P05: "Update account",
      BAR_P06: "End account",
      BAR_P10: "Transmit ambulatory payment classification(apc)",
      BAR_P12: "Update diagnose/procedure",
      BPS_O29: "Bps message",
      BRP_O30: "Brp message",
      BRT_O32: "Brt message",
      BTS_O31: "Bts message",
      CRM_C01: "Register a patient on a clinical trial",
      CSU_C09: "Automated time intervals for reporting, like monthly",
      DFT_P03: "Post detail financial transaction",
      DFT_P11: "Detail financial transactions",
      DOC_T12: "Document response",
      DSR_Q01: "Display response message",
      DSR_Q03: "Deferred response to a query",
      EAC_U07: "Automated equipment command",
      EAN_U09: "Automated equipment notification",
      EAR_U08: "Automated equipment response",
      EDR_R07: "Enhanced display response",
      EQQ_Q04: "Embedded query language query",
      ERP_R09: "Event replay response",
      ESR_U02: "Automated equipment status request",
      ESU_U01: "Automated equipment status update",
      INR_U06: "Automated equipment inventory request",
      INU_U05: "Automated equipment inventory update",
      LSU_U12: "Automated equipment log/service update",
      MDM_T01: "Original document notification",
      MDM_T02: "Original document notification and content",
      MFK_M01: "Master file application acknowledgment",
      MFN_M02: "Master file - staff practitioner",
      MFN_M04: "Master files charge description",
      MFN_M05: "Patient location master file",
      MFN_M06: "Clinical study with phases and schedules master file",
      MFN_M07: "Clinical study without phases but with schedules master file",
      MFN_M08: "Test/observation (numeric) master file",
      MFN_M09: "Test/observation (categorical) master file",
      MFN_M10: "Test/observation batteries master file",
      MFN_M11: "Test/calculated observations master file",
      MFN_M12: "Master file notification message",
      MFN_M13: "Master files notification",
      MFN_M15: "Master files notification",
      MFQ_M01: "Query for master file record",
      MFR_M04: "Master files response",
      MFR_M05: "Master files response",
      MFR_M06: "Master files response",
      MFR_M07: "Master files response",
      NMD_N02: "Application management data message",
      NMQ_N01: "Application management query message",
      NMR_N01: "Application management response",
      OMB_O27: "Omb message",
      OMD_O03: "Diet order",
      OMG_O19: "General clinical order",
      OMI_O23: "Omi message",
      OML_O21: "Laboratory order",
      OML_O33: "Laboratory order message",
      OML_O35: "Laboratory order message",
      OMN_O07: "Non-stock requisition order",
      OMP_O09: "Pharmacy/treatment order",
      OMS_O05: "Stock requisition order",
      ORB_O28: "Orb message",
      ORD_O04: "Diet order acknowledgement",
      ORF_R04: "Response to query; transmission of requested observation",
      ORG_O20: "General clinical order response",
      ORI_O24: "Ori message",
      ORL_O22: "Response message to oml",
      ORL_O36: "Laboratory acknowledgment message",
      ORM_O01: "Order message",
      ORN_O08: "Non-stock requisition acknowledgement",
      ORP_O10: "Pharmacy/treatment order acknowledgement",
      ORR_O02: "Order response",
      ORS_O06: "Stock requisition acknowledgement",
      ORU: "Unsolicited transmission of an observation message",
      ORU_R01: "Unsolicited transmission of an observation message",
      ORU_R30: "Unsolicited transmission of an observation message",
      OSQ_Q06: "Query for order status",
      OSR_Q06: "Query response for order status",
      OUL_R21: "Unsolicited laboratory observation",
      OUL_R22: "Unsolicited laboratory observation message",
      OUL_R23: "Unsolicited laboratory observation message",
      OUL_R24: "Unsolicited laboratory observation message",
      PEX_P07: "Unsolicited initial individual product experience report",
      PMU_B01: "Add personnel record",
      PMU_B03: "Delete personnel re cord",
      PMU_B04: "Active practicing person",
      PMU_B07: "Add personnel record",
      PMU_B08: "Add personnel record",
      QBP_K13: "Query by parameter",
      QBP_Q11: "Query by parameter",
      QBP_Q13: "Query by parameter",
      QBP_Q21: "Query by parameter",
      QBP_Q22: "Query - Find Candidates",
      QBP_Z73: "Query by parameter",
      QCK_Q02: "Deferred query",
      QCN_J01: "Cancel query/acknowledge message",
      QRY: "Query",
      QRY_A19: "Patient query",
      QRY_PC4: "Problem query",
      QRY_Q01: "Query sent for immediate response",
      QRY_Q02: "Query sent for deferred response",
      QRY_R02: "Query for results of observation",
      QSB_Q16: "Create subscription",
      RAR_RAR: "Pharmacy/treatment administration information",
      RAS_O17: "Pharmacy/treatment administration",
      RCI_I05: "Return clinical information",
      RCL_I06: "Return clinical information",
      RDE_O11: "Pharmacy/treatment encoded order",
      RDR_RDR: "Pharmacy/treatment dispense information",
      RDS_O13: "Pharmacy/treatment dispense",
      RDY_K15: "Display based response",
      REF_I12: "Patient referral",
      RER_RER: "Pharmacy/treatment encoded order information",
      RGR_RGR: "Pharmacy/treatment dose information",
      RGV_O15: "Pharmacy/treatment give",
      ROR_ROR: "Pharmacy prescription order query response",
      RPA_I08: "Return patient authorization",
      RPI_I01: "Return patient information",
      RPI_I04: "Return patient information",
      RPL_I02: "Return patient display list",
      RPR_I03: "Return patient list",
      RQA_I08: "Request for treatment authorization information",
      RQC_I05: "Request for patient clinical information",
      RQI_I01: "Request for insurance information",
      RQP_I04: "Request patient demographics",
      RQQ_Q09: "Event replay query",
      RRA_O18: "Pharmacy/treatment administration acknowledgement",
      RRD_O14: "Pharmacy/treatment dispense acknowledgement",
      RRE_O12: "Pharmacy/treatment encoded order acknowledgement",
      RRG_O16: "Pharmacy/treatment give acknowledgement",
      RRI_I12: "Return referral information",
      RSP_K11: "Segment pattern response",
      RSP_K21: "Segment pattern response",
      RSP_K22: "Segment pattern response",
      RSP_K23: "Segment pattern response",
      RSP_K25: "Segment pattern response",
      RSP_K31: "Segment pattern response",
      RSP_Q11: "Segment pattern response",
      RSP_Z82: "Segment pattern response",
      RSP_Z86: "Segment pattern response",
      RSP_Z88: "Segment pattern response",
      RSP_Z90: "Segment pattern response",
      RTB_K13: "Tabular response",
      RTB_Z74: "Tabular response",
      SIU_S12: "Notification of new appointment booking",
      SIU_S13: "Notification of Appointment Rescheduling",
      SIU_S14: "Notification of Appointment Modification",
      SIU_S15: "Notification of Appointment Cancellation",
      SIU_S16: "Notification of Appointment Discontinuation",
      SIU_S17: "Notification of Appointment Deletion",
      SIU_S18: "Notification of Addition of Service/Resource on Appointment",
      SIU_S19: "Notification of Modification of Service/Resource on Appointment",
      SIU_S20: "Notification of Cancellation of Service/Resource on Appointment",
      SIU_S21: "Notification of Discontinuation of Service/Resource on Appointment",
      SIU_S22: "Notification of Deletion of Service/Resource on Appointment",
      SIU_S23: "Notification of Blocked Schedule Time Slot(S)",
      SIU_S24: "Notification of Opened (un-blocked) Schedule Time Slot(s)",
      SIU_S26: "Notification That Patient Did Not Show Up for Scheduled Appointment",
      SPQ_Q08: "Stored procedure request",
      SQM_S25: "Schedule query message and response",
      SQR_S25: "Schedule query message and response",
      SRM_S01: "Request new appointment booking",
      SRR_S01: "Scheduled request response",
      SSR_U04: "Specimen status request",
      SSU_U03: "Specimen status update",
      TBR_R08: "Tabular data response",
      TCU_U10: "Automated equipment test code settings update",
      UDM_Q05: "Unsolicited display update message",
      VQQ_Q07: "Virtual table query",
      VXQ_V01: "Query for vaccination record",
      VXR_V03: "Vaccination record response",
      VXU_V04: "Unsolicited vaccination record update",
      VXX_V02: "Response to vaccination query"
    },
    enrollment_result: {
      arrival_is_outdated: "Arrival date is too far in the past.",
      arrival_is_too_close: "Arrival date is too close in time.",
      call_on_date_is_outdated: "Call On Date date is too far in the past.",
      custom_message: "All outreach actions have custom messages.",
      discharge_is_outdated: "Discharge date is too far in the past.",
      duplicate_call_within_interval: "Patient was called or is scheduled for a call which meets the duplicate call detection period.",
      encounter_not_found: "No encounter found for selected outreach program.",
      encounter_not_match: "Enrollment Failed: Patient does not have an encounter that meets criteria",
      encounter_status: "Patient's encounter status can not be matched.",
      enrollment_limit_reached: "The maximum number of active enrollments has been reached for that outreach program.",
      interaction_exists: "There is an interaction already for this encounter and outreach program's actions.",
      invalid_phone_format: "Patient's phone number format is invalid.",
      outreach_program_inactive: "The outreach program should be activated before assigning any patients.",
      outreach_program_not_completed: "The program is configured to wait for completion before allowing further enrollments.",
      outreach_program_not_matched: "The patient could not be enrolled in the selected program.",
      patient_blocked: "This patient is blocked and cannot be called.",
      patient_deceased: "This patient is marked as deceased and cannot be called.",
      patient_preference: "Patient's preferred contact method is not compatible with selected program.",
      phone_blocked: "Phone number on the do not call list.",
      pivot_date_is_outdated: "Pivot date is too far in the past.",
      pivot_date_is_too_close: "Pivot date is too close in time.",
      repeats_exist: "A previous enrollment with repeats is still ongoing.",
      success: "The patient is now enrolled in the selected program.",
      reenrollment_error: "The patient cannot be enrolled in the selected program because re-enrollment is not allowed."
    },
    interaction: {
      start_error: {
        call_limit: "Limit of 190 active calls has been reached. Please wait for a minute and repeat.",
        collaborative_not_supported: "This collaborative rounding script can only be started from the updated rounding page.",
        no_questions: "The selected outreach action does not have any questions.",
        patient_blocked: "This patient is blocked and can not be called.",
        patient_deceased: "This patient is marked as deceased and cannot be called.",
        phone_blocked: "Phone number on the do not call list.",
        successful_sms: "The patient is being texted right now.",
        successful_voice: "The patient is being called right now.",
        improper_time_to_launch: "We cannot make calls between 10PM and 6AM."
      }
    },
    issue_panels: {
      caregram_will_be_sent_later: "Your caregram will be sent after closing the issue.",
      caregram_already_sent: "Your caregram was already sent."
    },
    dynamic_info: "Dynamic questions allow to dynamically decide what to ask patients based on the current state at the time of calling.",
    free_text_info: "Free-text questions allow to gather more information about the patient as they don't have answer options.\nThey can't trigger issues so use them sparingly.",
    good_performace_email: "Good performace email",
    issue_panel_info: "Issue Panel",
    issue_alert_info: "Issue Alert",
    flag_info: "Triggers Flag",
    tag_info: "Adds Tag",
    untag_info: "Removes Tag",
    unflag_info: "Removes Flag",
    allow_attachments: "Allow Attachments",
    rounding_recent_patients_empty: "You haven't rounded any patients recently.",
    rounding_instructions: "To begin, select a Rounding Program, search Admitted patients (on the right panel) and click their name.",
    free_text_placeholder: "Response here",
    never_rounded: "Not rounded yet",
    web_based_program: {
      activate_confirmation_message: "The program will be <strong>activated</strong>.",
      deactivate_confirmation_message: "The program will be <strong>deactivated</strong>."
    },
    export_started: "Export started, you should soon receive an email with a link to access the file. You can check the status of any pending exports by clicking <a href=\"%{exports_link}\" class=\"anchor underline-always\">here</a>.",
    export_already_running: "An export with the same filters is already scheduled. You can check the status of any pending exports by clicking <a href=\"%{exports_link}\" class=\"anchor underline-always\">here</a>.",
    export_pdf_started: "Export started, you should soon receive an email with a link to access the file so you can download or print it. You can check the status of any pending exports by clicking <a href=\"%{exports_link}\" class=\"anchor underline-always\">here</a>.",
    export_job: {
      recent_mode_warning: "By setting this export job to 'Recent' type, it will require an initial run of data.<br/> Please consider setting a start date (i.e. 'Export Data Since') for this initial run. If no start date, this means the entire content of the data view results at the time of job run will be included and this may be very large.<br/> Please inform the Product team that oversees Exports if you will be setting up a new export with 'Recent' type and no start date or a start date very far in the past, resulting in a large sum of data to be exported.",
      total_mode_warning: "By setting this export job to 'Total' type, it may export a growing amount of data, which may cause an unsustainable load in the system in the long run.<br/> Please inform the Product team that oversees Exports if you will be setting up a new export with 'Total' type."
    },
    outreach: {
      stop_confirmation: "You are unsubscribed from CipherHealth Texts. No more messages will be sent. Reply HELP for help or contact %{support_email}.",
      stop_program_message: "You are unsubscribed from %{short_name} program. No more messages will be sent from this program. Reply HELP for help or more help at %{support_email}. Reply STOP to cancel all programs.",
      help_message: "CipherHealth Text. More help at %{support_email} or %{support_phone}. 8 msgs/week. Msg&Data rates may apply. Reply STOP to cancel all programs. Reply STOP %{short_name} to unsubscribe from this program.",
      help_message_phone_only: "CipherHealth Text. More help at %{support_phone}. 8 msgs/week. Msg&Data rates may apply. Reply STOP to cancel all programs. Reply STOP %{short_name} to unsubscribe from this program.",
      help_message_email_only: "CipherHealth Text. More help at %{support_email}. 8 msgs/week. Msg&Data rates may apply. Reply STOP to cancel all programs. Reply STOP %{short_name} to unsubscribe from this program."
    },
    outreach_program: {
      duplicated_phone: "The phone number you entered is currently being used by another <a href=\"%{cp_link}\">outreach program</a>. Please try another number if this is a Twilio number or patients will not be able to call inbound. If this is not a Twilio number inbound calling is already disabled so you can continue to use a number shared by another program.",
      duplicated_phone_vue_program: "The phone number you entered is currently being used by program ",
      duplicated_phone_vue_message: "Please try another number if this is a Twilio number or patients will not be able to call inbound. If this is not a Twilio number inbound calling is already disabled so you can continue to use a number shared by another program.",
      activate_confirmation_message: "Calls in the IQ will be reviewed and re-assigned to the highest priority <strong>active</strong> Outreach Program.",
      launch_confirmation_message: "Calls will be launched <strong>inmediately</strong>.",
      pause_confirmation_message: "The program will be <strong>paused</strong> and calls will not go out.",
      resume_confirmation_message: "Calls will be launched in the <strong>next call hour</strong>."
    },
    password_requirements: {
      minimum_length: "*Password must contain at least %{number} characters",
      caps: "*Password must contain at least one upper case letter",
      special: "*Password must contain at least one special character",
      numeric: "*Password must contain at least one numeric character",
      different_than_recent: "*Password must be different from passwords you've used in the past",
      disallow_similar: "*Password is too similar to your current password",
      cannot_be_email: "*Password cannot be the same as e-mail",
      cannot_contain_email: "*Password cannot contain the e-mail",
      cannot_be_user_name: "*Password cannot be the same as user name",
      cannot_contain_user_name: "*Password cannot contain the user name"
    },
    provider_role: {
      errors: {
        users_association: "%{users} with this role in this CP. Please ensure no users have this role by unassigning it before attempting to delete it."
      }
    },
    errors: {
      attributes: {
        sso_username: {
          invalid: "should be in format DOMAIN\\username.",
          taken: "The SSO Username entered already exists, please use a different one or contact your administrator."
        }
      },
      messages: {
        invalid_date: "is not a valid date",
        invalid_time: "is not a valid time",
        invalid_datetime: "is not a valid datetime",
        is_at: "must be at %{restriction}",
        before: "must be before %{restriction}",
        on_or_before: "must be on or before %{restriction}",
        after: "must be after %{restriction}",
        on_or_after: "must be on or after %{restriction}"
      }
    },
    data_view: {
      alerts: {
        update_default_view: "At least one view of this type is required to be default so %{name} has been updated to be the default view. You can change this in the configuration."
      }
    },
    file_imports: {
      hints: {
        users_csv: "Fields mapped to Role needs to contain the name of a role in the system. E.g: <i>Simple User</i> or <i>Care Provider Admin</i>. Boolean fields like <i>iOS Only User</i> and <i>SSO Enabled</i> needs to contain the string <i>on</i> to be enabled.",
        care_gram_emails_csv: "This file import supports .csv and .xlsx files. In the next step you will be able to map one column in the uploaded file to be imported as Care Gram E-mails in the system"
      }
    },
    care_form: {
      name: "Care Forms",
      inputs: {
        date_time_input: "Date-Time Input",
        read_only_input: "Read-Only Input"
      },
      mappings: {
        create_new_key_metric_mapping: "Create New Key Metric Mapping",
        no_mapping: "No Mapping",
        one_to_one_mapping: "One-To-One Mapping"
      },
      plugins: {
        create_comment_plugin: "Create Comment Plugin"
      },
      validations: {
        presence_validation: "Must Be Present"
      }
    },
    encounter_criterium: {
      missing_configuration: "You must select at least one of the following before saving: issue panel, issue alert, rounding flag, view blueprints or patient tags."
    },
    medication_criterium: {
      missing_configuration: "You must select at least one of the following before saving: issue panel or issue alert."
    },
    staff_member_criterium: {
      missing_configuration: "You must select at least one of the following before saving: staff rounding flag"
    },
    key_metric: {
      bmi: "BMI",
      bmi_threshold: "BMI",
      engagement_score: "Engagement Score",
      gad7: "GAD-7",
      inr: "INR",
      karnofsky_score: "Karnofsky Score",
      lace: "LACE",
      moca: "MoCA",
      pam_level: "PAM Level",
      pam_score: "PAM Score",
      pam_threshold: "PAM",
      pcl5: "PCL-5",
      psa_density: "PSA Density",
      psa_level: "PSA Level",
      blood_pressure: "Blood Pressure",
      phq9: "PHQ-9",
      sds: "SDS",
      hoos: "HOOS",
      koos: "KOOS",
      odi_score: "ODI Score",
      unit: {
        kilograms_per_meter_squared: "kg/m²",
        kilopascals_grouped: "Kilopascals",
        millimeters_of_mercury: "Millimeters of Mercury",
        millimeters_of_mercury_grouped: "Millimeters of Mercury",
        nanograms_per_milliliter: "Nanograms Per Milliliter",
        nanograms_per_milliliter_per_cubic_centimeter: "Nanograms Per Milliliter Per Cubic Centimeter",
        float: "",
        integer: ""
      }
    },
    key_metric_source: {
      FitbitAccount: "Fitbit",
      JawboneAccount: "Jawbone",
      IhealthAccount: "iHealth"
    },
    user_invitation: {
      alerts: {
        sso_username_rejected: "SSO username has not been updated because different value is already set. You can change this in the configuration."
      }
    },
    pam: {
      PA1: "When all is said and done, I am the person who is responsible for taking care of my health.",
      PA2: "Taking an active role in my own health care is the most important thing that affects my health.",
      PA4: "I know what each of my prescribed medications do.",
      PA5: "I am confident that I can tell whether I need to go to the doctor or whether I can take care of a health problem myself.",
      PA6: "I am confident that I can tell a doctor concerns I have even when he or she does not ask.",
      PA7: "I am confident that I can follow through on medical treatments I may need to do at home.",
      PA10: "I have been able to maintain (keep up with) lifestyle changes, like eating right or exercising.",
      PA11: "I know how to prevent problems with my health.",
      PA12: "I am confident I can figure out solutions when new problems arise with my health.",
      PA13: "I am confident that I can maintain lifestyle changes, like eating right and exercising, even during times of stress.",
      answer0: "N/A",
      answer1: "Strongly Disagree",
      answer2: "Disagree",
      answer3: "Agree",
      answer4: "Strongly Agree"
    },
    patient: {
      errors: {
        already_exists_with_encounter: "A patient and encounter with this information already exists. Please change your information and try again or visit that existing patient <a href=\"%{link}\">here</a>"
      }
    },
    patient_matching: {
      default: "Default matching algorithm",
      mrn: "MRN",
      mrn_alternative_id: "MRN and Alternate Patient ID",
      mrn_dob: "MRN and Date Of Birth",
      mrn_facility: "MRN and Facility",
      attuned_care: "First Name, Last Name, Date Of Birth, Member ID",
      pps: "First Name, Last Name, Date Of Birth, Encounter ID",
      fn_ln_medicaid_id: "First Name, Last Name, Medicaid ID",
      fn_ln_encounter_id: "First Name, Last Name, Encounter ID",
      fn_ln_dob: "First Name, Last Name, Date Of Birth",
      member_id: "Member ID",
      patient_mrn: "Patient MRN"
    },
    converters: {
      map_value: {
        name: "Map Value",
        empty_summary: "If value is empty string then replace it with <b>%{new_value}</b>.",
        summary: "If value is equal to <b>%{old_value}</b> then replace it with <b>%{new_value}</b>.",
        note: "Edit to visualize all available mappings."
      }
    },
    disenrollment_reasons: {
      encounter_merge: "Disenrollment has been triggered by dupes finder for duplicated encounter.",
      expired_echo: "Disenrollment has been triggered because discharge date reached the expiration limit. By default it is 30 days, but it can be defined either on Care Provider level in 'Expire Care Recordings Access' or on Outreach Action level in 'Expiration Shift' setting.",
      foreign_number_not_allowed: "Disenrollment has been triggered because care provider does not allow to call foreign numbers.",
      manual_ui_removal: "Disenrollment has been triggered manually by the user.",
      no_program_matched: "Disenrollment has been triggered because there is no outreach programs from enroll attempts (Interaction Enrollers) and encounter does not match any outreach program criteria. We disenroll all calls for given encounter without those enrolled manually.",
      observer_post_admit_removal_for_encounter_status_change: "Disenrollment has been triggered because status of encounter has been changed and is not currently 'In progress'. In such case we check all post admit programs for given encounter and disenroll all scheduled calls.",
      overcalling_protection: "Disenrollment has been triggered by an Overcalling Protection Rule matched during call launch checks.",
      patient_blocked: "Disenrollment has been triggered because patient has been blocked. Manual action from blocked patients page.",
      patient_is_currently_admitted: "Disenrollment has been triggered after import because patient is marked as currently admitted. We disenroll calls for encounters from inpatient units without pre admit outreach programs.",
      patient_opted_out: "Disenrollment has been triggered because call attempt status has been changed to 'Opt Out'.",
      program_stopped: "Disenrollment has been triggered because Outreach Program has been stopped.",
      unschedule_from_other_outreach_programs: "During enrollment process we disenroll from other outreach programs. We omit all calls which have been triggered manually.",
      unschedule_from_same_outreach_program_for_call_on_date: "<i>Call On Date</i> enroller. We disenroll all patient calls for same outreach program and same date but different encounters and also patient calls for same outreach program, same encounter but different dates.",
      unschedule_from_same_outreach_program_for_post_admit: "<i>Post Admit</i> enroller. We disenroll all patient calls for same outreach program.",
      unschedule_from_same_outreach_program_for_post_discharge: "<i>Post Discharge</i> enroller. We disenroll all patient calls for same outreach program and same date but different encounters and all patient calls for same outreach program but different date.",
      unschedule_from_same_outreach_program_for_pre_admit: "<i>Pre Admit</i> enroller. If there is any repeat questions we do not disenroll for same date for given outreach action if there id no repeat questions then we disenroll all patient calls for same outreach program and same date but different encounters and also patient calls for same outreach program, same encounter but different dates.",
      unschedule_on_failed_enrollment_update: "Failed Enrollment on Source Object update triggered Disenrollment of prior Enrollment"
    },
    manual_event_reasons: {
      disenrollment: "Disenrollment has been triggered manually by %{user_email}",
      enrollment: "Enrollment has been triggered manually by %{user_email}",
      reschedule: "Reschedule has been triggered manually by %{user_email}"
    },
    data_exchange: {
      outbound_messages_settings: {
        call_attempt_export: "Call Data",
        interaction_export: "Interaction Export"
      }
    },
    associations: {
      patients: {
        patient: {
          add_tags: "Tags (Add)",
          remove_tags: "Tags (Remove)",
          mrn: "Patient MRN"
        },
        diagnosis: {
          name: "Diagnosis Name",
          related_encounter_id: "Related Encounter ID",
          status: "Diagnosis Status"
        },
        encounter: {
          appointment_id: "Appointment ID",
          department_id: "Department ID",
          encounter_free_text_type: "Encounter Free Text Type",
          encounter_type: "Encounter Type",
          medication_code: "Encounter Medication Code",
          provider_patient_id: "Provider Patient ID",
          visit_type_id: "Visit Type ID"
        },
        referral: {
          referral_id: "Referral ID",
          referred_to_provider_id: "Referred To Provider ID",
          referred_to_department_id: "Referred To Department ID"
        },
        medication: {
          dosage_unit: "Medication Dosage Unit",
          dosage_value: "Medication Dosage Value",
          end_date: "Medication End Date",
          frequency: "Medication Frequency",
          name: "Medication Name",
          pharmacy: "Medication Pharmacy",
          prescription_id: "Medication Prescription ID",
          prescribing_location: "Prescribing Location",
          quantity: "Medication Quantity",
          quantity_unit: "Medication Unit",
          prescriber: "Medication Prescriber",
          prescription_date: "Medication Prescription Date",
          route: "Medication Route",
          start_date: "Medication Start Date",
          status: "Medication Status",
          type: "Medication Type"
        },
        unit: {
          facility: "Unit Facility",
          group: "Unit Group",
          name: "Unit Name",
          phonetic_spelling: "Unit Phonetic Spelling"
        },
        observation: {
          finished_at: "Observation Finished At",
          name: "Observation Name",
          reason: "Observation Reason",
          started_at: "Observation Started At",
          type: "Observation Type"
        },
        observation_result: {
          measured_at: "Observation Result Measured At",
          name: "Observation Result Name",
          references_range: "Observation Result References Range",
          status: "Observation Result Status",
          unit: "Observation Result Unit",
          value: "Observation Result Value"
        }
      },
      readmissions: {
        encounter: {
          provider_patient_id: "Provider Patient ID"
        }
      },
      staff_members: {
        department: {
          facility: "Department Facility",
          group: "Department Group",
          name: "Department Name"
        },
        survey_location: {
          facility: "Survey Location Facility",
          name: "Survey Location Name"
        },
        shift_department: {
          facility: "Shift Department Facility",
          group: "Shift Department Group",
          name: "Shift Department Name"
        }
      },
      survey_devices: {
        survey_location: {
          name: "Location"
        }
      },
      survey_patient_devices: {
        survey_patient_device: {
          rounding_script_ids: "Survey"
        }
      },
      survey_locations: {
        survey_location: {
          name: "Location"
        }
      },
      locations: {
        location_group: {
          facility: "Location Group Facility",
          name: "Location Group Name"
        }
      },
      units: {
        unit: {
          facility: "Unit Facility",
          facility_short_title: "Unit Facility Short Title",
          group: "Unit Group",
          name: "Unit Name",
          short_title: "Unit Short Title",
          phonetic_spelling: "Unit Phonetic Spelling",
          building_code: "Unit Building Code",
          roundable: "Unit Roundable?",
          roundable_types: "Unit Roundable Types",
          time_zone: "Unit Time Zone"
        }
      },
      users: {
        user: {
          employer_id: "Employer ID"
        }
      }
    },
    report_packages: {
      default_email_body: "Hello, <br> <br>This reporting package contains key reports for your organization. If you have any questions regarding the reports, please reply to this email and our team will get back to you as soon as we can. Have a great day! <br> <br>Sincerely, <br>CipherHealth"
    },
    time_zones: {
      est: "Eastern Time",
      edt: "Eastern Time",
      cst: "Central Time",
      cdt: "Central Time",
      mst: "Mountain Time",
      mdt: "Mountain Time",
      pst: "Pacific Time",
      pdt: "Pacific Time",
      hst: "Hawaii–Aleutian Time",
      hdt: "Hawaii–Aleutian Time",
      akst: "Alaska Time",
      akdt: "Alaska Time"
    }
  }
}

